import { memo } from "react";

function UnacknowledgedMarker(props) {
  const {
    backgroundColor = "#E5A70D",
    borderColor = "white",
    size = 27,
  } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11147_48989)">
        <path
          d="M22 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V22C0.5 22.8284 1.17157 23.5 2 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V2C23.5 1.17157 22.8284 0.5 22 0.5Z"
          fill={backgroundColor}
        />
        <path
          d="M5.30625 5.30625C5.51042 5.10208 5.75826 5 6.04996 5H14.4502C14.7417 5 14.9898 5.10208 15.1939 5.30625C15.3233 5.43546 15.4119 5.5822 15.4591 5.7465C15.4864 5.8422 15.5002 5.94269 15.5002 6.04956V9.3753H14.4502V6.04956H6.04996V17.9504H9.20004V19H6.04996C5.91557 19 5.79056 18.9777 5.67472 18.9346C5.53914 18.8852 5.41632 18.8038 5.30625 18.6937C5.10208 18.4896 5 18.2423 5 17.9504V6.04956C5 5.75766 5.10208 5.51042 5.30625 5.30625Z"
          fill={borderColor}
        />
        <path
          d="M7.80005 9.02612V7.97656H12.7001V9.02612H7.80005Z"
          fill={borderColor}
        />
        <path
          d="M7.80005 10.0762V11.1258H11.3001V10.0762H7.80005Z"
          fill={borderColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6001 17.6693V18.9996H19.0002V17.6693C19.0002 17.6151 18.9972 17.5624 18.9912 17.5098C18.9825 17.4332 18.9677 17.3583 18.9468 17.2865C18.9165 17.1796 18.873 17.0775 18.8166 16.9786C18.6939 16.7633 18.5277 16.591 18.3177 16.4618C17.781 16.1476 17.2181 15.9083 16.6289 15.744C16.0397 15.5813 15.4302 15.5 14.8002 15.5C14.3922 15.5 13.9928 15.5335 13.6021 15.6021C13.3893 15.6404 13.179 15.6866 12.9714 15.744C12.3822 15.9083 11.8194 16.1476 11.2826 16.4618C11.0727 16.591 10.9064 16.7633 10.7838 16.9786C10.7413 17.0536 10.706 17.1302 10.6783 17.2083C10.626 17.3551 10.6001 17.5098 10.6001 17.6693ZM17.9502 17.4428V17.95H11.6501V17.4603C11.8305 17.3567 12.0134 17.261 12.1986 17.1732C12.5164 17.0249 12.841 16.8973 13.1728 16.7952C13.6978 16.6309 14.2401 16.5496 14.8002 16.5496C15.3602 16.5496 15.9028 16.6293 16.4277 16.7872C16.5522 16.8239 16.6758 16.8638 16.7984 16.9085C17.1926 17.0504 17.5766 17.2291 17.9502 17.4428Z"
          fill={borderColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8004 14.7995C14.217 14.7995 13.7211 14.5953 13.3127 14.1869C12.9044 13.7786 12.7002 13.2825 12.7002 12.7003C12.7002 12.1165 12.9044 11.6205 13.3127 11.2121C13.7211 10.8038 14.217 10.5996 14.8004 10.5996C15.3836 10.5996 15.8794 10.8038 16.2878 11.2121C16.5167 11.4418 16.6814 11.697 16.782 11.981C16.8608 12.2043 16.9003 12.4435 16.9003 12.7003C16.9003 13.2825 16.6961 13.7786 16.2878 14.1869C15.8794 14.5953 15.3836 14.7995 14.8004 14.7995ZM14.8004 13.7499C15.1036 13.7499 15.3544 13.6478 15.5528 13.4436C15.6521 13.3416 15.7265 13.2283 15.7761 13.1039C15.8256 12.9795 15.8503 12.8455 15.8503 12.7003C15.8503 12.3957 15.751 12.1452 15.5528 11.9475C15.3544 11.7481 15.1036 11.6492 14.8004 11.6492C14.5087 11.6492 14.2606 11.7481 14.0565 11.9475C13.9041 12.0958 13.8086 12.2713 13.7699 12.4786C13.7568 12.5488 13.7502 12.6222 13.7502 12.7003C13.7502 12.9922 13.8523 13.2395 14.0565 13.4436C14.2606 13.6478 14.5087 13.7499 14.8004 13.7499Z"
          fill={borderColor}
        />
        <path
          d="M22 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V22C0.5 22.8284 1.17157 23.5 2 23.5H22C22.8284 23.5 23.5 22.8284 23.5 22V2C23.5 1.17157 22.8284 0.5 22 0.5Z"
          stroke={borderColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_11147_48989">
          <rect width="24" height="24" fill={borderColor} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(UnacknowledgedMarker);
